import React from 'react'
import { useSelector } from 'react-redux'
import { Card, Row, Col, Typography, Timeline } from 'antd';
import Animate from 'rc-animate';
import { ClockCircleOutlined } from '@ant-design/icons';
import logocropped from '../assets/logoCropped.png'
import MyProfile from '../components/MyProfile';
import SignInForm from '../components/SignInForm';


const { Title, Text } = Typography;

const { Meta } = Card;

const Roadmap = () => {
    const user = useSelector(state => state.user)


    return (
        <>
        <Row gutter={[24, 24]} justify="center">
            <Col xs={24} sm={24} md={20} lg={16} xl={14}  > 
            <Animate
                    transitionName="fade"
                    transitionAppear
                >
                <Card
                    style={{
                        borderRadius: 10, 
                        marginBottom: 25,
                        boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
                    }}
                    title={<Row justify="center">
                            
                            <Title level={2} > 
                            <img src={logocropped} alt="Logo" 
                                style={{
                                    width:40,
                                    height:35,
                                }}
                            />
                                UPCOMING
                            </Title>
                    </Row>}
                >
                    <Timeline mode="alternate">
                        <Timeline.Item>
                            <Title level={5}>Traders Feed </Title>
                            <Text>Inside our Traders Feed you will be able to have your own trader profile. You will be able to post your charts or messages to everyone and also to comment and like other members posts. With our trader feed everyone inside the community will be able to share, discuss and post with each other.</Text>
                        </Timeline.Item>

                        <Timeline.Item>
                            <Title level={5}>Events Calendar</Title>
                            <Text>Calendar with all our upcoming live events.</Text>
                        </Timeline.Item>

                        <Timeline.Item>
                            <Title level={5}>Trader Tools </Title>
                            <Text>Economical Calendar, Live Forex Rates, Cryptocurrencies Prices and More. All in one place for you.</Text>
                        </Timeline.Item>

                        <Timeline.Item>
                            <Title level={5}>Traders Map </Title>
                            <Text>Interactive map where you can find local traders. Our map will show different places of our members, so you can find more traders in your local area. </Text>
                        </Timeline.Item>

                        <Timeline.Item>
                            <Title level={5}>E-Shop</Title>
                            <Text>E-Shop with Odin merchandise and other Odin branded goods.</Text>
                        </Timeline.Item>

                        <Timeline.Item>
                            <Title level={5}>Mobile Apps</Title>
                            <Text>Odin mobile applications for iOS and Android.</Text>
                        </Timeline.Item>
                        
                        <Timeline.Item dot={<ClockCircleOutlined style={{ fontSize: '16px' }} />}>
                            <Title level={5}>And many more features...</Title>
                            <Text>Other upcoming features will be annnouced later on.</Text>
                        </Timeline.Item>
                    </Timeline>
                </Card>
            </Animate>
            </Col>

            
            <Col xs={24} sm={18} md={12} lg={8} xl={8}  > 
            <Animate
                    transitionName="fade"
                    transitionAppear
                >
                { user.jwt ?
                    <MyProfile/>
                    :
                        <Card
                            style={{
                                borderRadius: 10, 
                                marginBottom: 25,
                                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
                            }}
                        >
                            <SignInForm/>
                        </Card>
                }
                

            </Animate>
            </Col>
        </Row>
        </>
    )
}

export default Roadmap
